module.exports = __webpack_public_path__ + "static/media/arrow-down-circle.f7a8ceef.svg";